"use client";

import PropTypes from "prop-types";

import classNames from "classnames";

import SalePanel from "components/homepage/showcase-tab-panels/sale-panel";
import RentPanel from "components/homepage/showcase-tab-panels/rent-panel";
import ListingIdPanel from "components/homepage/showcase-tab-panels/listing-id-panel";
import EstateOfficePanel from "components/homepage/showcase-tab-panels/estate-office-panel";
import ProjectsPanel from "components/homepage/showcase-tab-panels/projects-panel";

import { getSaleCategories } from "@/src/helpers/extract-category-childs";
import { Tab } from "@headlessui/react";

import styles from "./styles.module.css";

const ShowcaseTabWrapper = ({ categoryTree, page }) => {
  const categories =
    page === "not-found"
      ? ["Satılık", "Kiralık", "Projeler"]
      : ["Satılık", "Kiralık", "Projeler", "Emlak Ofisleri", "İlan No"];

  const saleCategories = getSaleCategories({
    data: categoryTree,
    categoryToExtract: "Satılık",
  });

  const rentCategories = categoryTree?.find((item) => item?.name === "Kiralık");
  const projectCategories = categoryTree?.find((item) => item?.name === "Projeler");

  const tabPanelClass = classNames({
    [styles.tabpanel]: true,
    [styles.tabpanelnotfound]: page === "not-found",
  });

  const tabListClass = classNames({
    [styles.tab]: true,
    [styles.tablistnotfound]: page === "not-found",
  });

  return (
    <div className={styles.wfull}>
      <Tab.Group>
        <Tab.List>
          {categories.map((category) => (
            <Tab
              key={category}
              className={({ selected }) => `${tabListClass} ${selected ? styles.tabselected : styles.tabnotselected}`}
            >
              {category}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel className={tabPanelClass}>
            <SalePanel saleCategories={saleCategories} pageType={page} />
          </Tab.Panel>
          <Tab.Panel className={tabPanelClass}>
            <RentPanel rentCategories={rentCategories} pageType={page} />
          </Tab.Panel>
          <Tab.Panel className={tabPanelClass}>
            <ProjectsPanel projectCategories={projectCategories} pageType={page} />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <EstateOfficePanel />
          </Tab.Panel>
          <Tab.Panel className={styles.tabpanel}>
            <ListingIdPanel />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

ShowcaseTabWrapper.propTypes = {
  categoryTree: PropTypes.any,
  page: PropTypes.string,
};

export default ShowcaseTabWrapper;
